// The Groundwork logo in three lockups.
// Paths are inline so they inherit theme colours and stay crisp.

export const MARK_PATH = "M49,9.2h-11.4l-23.3,23.3v11.4l9.2,9.2-14.9,14.9h11.5l9.2-9.2,9.2,9.2h11.4l23.3-23.3v-11.4l-24.1-24.1ZM45.6,58.6h-5s-16.9-16.9-16.9-16.9v-5s8-8,8-8l5,5c-1,1.4-1.5,3.1-1.5,4.9s.9,4.4,2.5,6.1c1.6,1.6,3.8,2.5,6.1,2.5s3.5-.5,4.9-1.5l5,5-8,8h0ZM48.5,41.2l-7.6-7.6c.8-.5,1.7-.7,2.7-.7,1.5,0,2.9.6,3.9,1.6s1.6,2.5,1.6,3.9-.3,1.9-.7,2.7h0ZM46.4,43.4c-.8.5-1.7.7-2.7.7-1.5,0-2.9-.6-3.9-1.6s-1.6-2.5-1.6-3.9.3-1.9.7-2.7M55.7,48.5l-5-5c1-1.4,1.5-3.1,1.5-4.9s-.9-4.4-2.5-6.1c-1.6-1.6-3.8-2.5-6.1-2.5s-3.5.5-4.9,1.5l-5-5,8-8h5l16.9,16.9v5l-8,8h.1Z";

const IDENT_PATH = "M49.1,11.6h-11.4l-23.3,23.3v11.4l9.2,9.2-14.9,14.9h11.5l9.2-9.2,9.2,9.2h11.4l23.3-23.3v-11.4l-24.1-24.1h0ZM45.7,61h-5l-16.9-16.9v-5l8-8,5,5c-1,1.4-1.5,3.1-1.5,4.9s.9,4.4,2.5,6.1c1.6,1.6,3.8,2.5,6.1,2.5s3.5-.5,4.9-1.5l5,5-8,8h0ZM48.6,43.6l-7.6-7.6c.8-.5,1.7-.7,2.7-.7,1.5,0,2.9.6,3.9,1.6s1.6,2.5,1.6,3.9-.3,1.9-.7,2.7h0ZM46.5,45.8c-.8.5-1.7.7-2.7.7-1.5,0-2.9-.6-3.9-1.6s-1.6-2.5-1.6-3.9.3-1.9.7-2.7M55.8,50.9l-5-5c1-1.4,1.5-3.1,1.5-4.9s-.9-4.4-2.5-6.1c-1.6-1.6-3.8-2.5-6.1-2.5s-3.5.5-4.9,1.5l-5-5,8-8h5l16.9,16.9v5l-8,8h.1Z";

const WORD_PATHS = [
  "M93.1,55.4V22.5l8-8h24.4l7.9,7.9v7.5h-9.5v-4l-3.3-3.3h-14.4l-3.6,3.6v25.6l3.6,3.6h14.6l3.4-3.4v-7.6h-10.5v-8.1h19.7v19.2l-8,8h-24.2l-8-8Z",
  "M189.5,47.2v16.2h-9.5v-14.1l-4.2-4.7h-15.3v18.8h-9.5V14.5h30.7l7.5,7.6v14.8l-4.8,4.8,5,5.5ZM160.5,36.9h16.9l2.5-2.4v-9.5l-2.5-2.5h-16.9v14.4Z",
  "M207.5,55.4V22.5l8-8h25.2l8,8v32.9l-8,8h-25.2l-8-8ZM235.7,55.3l3.6-3.6v-25.6l-3.6-3.6h-15.1l-3.6,3.6v25.6l3.6,3.6h15.1Z",
  "M267.1,55.1V14.5h9.5v37.3l3.6,3.6h13.7l3.6-3.6V14.5h9.5v40.6l-8.4,8.4h-23.1l-8.4-8.4Z",
  "M326.1,14.5h8.5l21.8,33.2h.1V14.5h9.2v49h-8.5l-21.8-33.2h-.1v33.2h-9.2V14.5Z",
  "M384.8,14.5h31.4l8.4,8.4v32.2l-8.4,8.4h-31.4V14.5ZM411.5,55.3l3.6-3.6v-25.6l-3.6-3.6h-17.2v32.8h17.2Z",
  "M439.4,14.5h9.6l6,34.6h.3l9.7-34.6h7.1l9.5,34.6h.3l6-34.6h9.6l-10.2,49h-8.9l-9.7-34.4h-.3l-9.9,34.4h-8.9l-10.2-49Z",
  "M512.3,55.4V22.5l8.1-8h25.2l8.1,8v32.9l-8.1,8h-25.2l-8.1-8ZM540.5,55.3l3.6-3.6v-25.6l-3.6-3.6h-15.1l-3.6,3.6v25.6l3.6,3.6h15.1Z",
  "M610.4,47.2v16.2h-9.5v-14.1l-4.2-4.7h-15.3v18.8h-9.5V14.5h30.7l7.5,7.6v14.8l-4.8,4.8,5,5.5ZM581.4,36.9h16.9l2.4-2.4v-9.5l-2.4-2.5h-16.9v14.4Z",
  "M629.1,14.5h9.5v20.5h7.4l11.8-20.5h10.7l-14.4,24.4,15.5,24.6h-10.9l-12.9-20.4h-7.3v20.4h-9.5V14.5Z",
];

export function LogoMark({ height = 26, colour = '#C9F235', style }) {
  return (
    <svg viewBox="8.6 9.2 64.6 69.8" style={{ height, width: 'auto', display: 'block', ...style }} aria-hidden="true">
      <path fill={colour} d={MARK_PATH} />
    </svg>
  );
}

export function LogoIdent({ size = 28, colour = '#C9F235', style }) {
  return (
    <svg viewBox="0 0 82 82" style={{ height: size, width: size, display: 'block', ...style }} aria-hidden="true">
      <path fill={colour} d={IDENT_PATH} />
    </svg>
  );
}

export function LogoWord({ height = 13, colour = '#F0F4FF', style }) {
  return (
    <svg viewBox="93 14 580 50" style={{ height, width: 'auto', display: 'block', ...style }} aria-hidden="true">
      <g fill={colour}>
        {WORD_PATHS.map((d, i) => <path key={i} d={d} />)}
      </g>
    </svg>
  );
}

// The horizontal lockup — mark + wordmark in a SINGLE svg so they keep the exact
// spacing and vertical alignment from the source artwork. The mark occupies
// x 8.6–73 and the word x 93–673 in one shared coordinate space; rendering them
// as two separately-sized svgs (as before) threw the alignment and proportion off.
export function LogoFull({ height = 24, markColour = '#C9F235', wordColour = '#F0F4FF', style }) {
  return (
    <svg viewBox="8.6 9.2 664.4 69.8" style={{ height, width: 'auto', display: 'block', ...style }} aria-hidden="true">
      <path fill={markColour} d={MARK_PATH} />
      <g fill={wordColour}>
        {WORD_PATHS.map((d, i) => <path key={i} d={d} />)}
      </g>
    </svg>
  );
}

export function LogoLockup({ markHeight = 24, style }) {
  return <LogoFull height={markHeight} style={style} />;
}
